var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):(_vm.page)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$showLocalizedField(_vm.page.content, _vm.locale).text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }